import React, { useState, useEffect, useCallback } from "react";
import "../../../Styles.css";
import "../../../reports/reports.css";
import { useHistory } from 'react-router-dom';
// import "../../../../ui-styles/contentHeading/contentHeading.css";
import "../../../../../ui-styles/search/Search.css";
import "../../../../../ui-styles/inlineLink/inlineLinkIcon.css";
// import Button from "../../../../../lib/ui/buttons/Button";
import "../../../../../lib/ui/buttons/BtnStyles.css";
import "../../../../../lib/ui/imageicon/Styles.css";
import Loader from "../../../../../lib/ui/loader/Loader";
import "../../../../../ui-styles/filterList/filterInput.css";
import "../../../../common/bookAppointment/BookAppointments.css";
import { getUsers, getAllAdmins } from "../../../../../actions/users";
import NoData from "../../../../../lib/ui/nodata/NoData";
// import DropDownSm from "../../../../../lib/ui/dropdown/DropdownSm";
import DropDown from "../../../../../lib/ui/dropdown/Dropdown";
import SlideInClinicProfile from "./ClinicProfileSlide";
import { Link } from "react-router-dom";
import ClinicListItem from "./ClinicListItem";
import {API} from "aws-amplify";
//const filterList = [{ value: "lastVisit", label: "Last Visit" }, { value: "Last Week", label: "Last Week" }, { value: "Last Month", label: "Last Month" }, { value: "Last Year", label: "Last Year" }, { value: "All", label: "All" },]
// const drop = [{ label: "10", value: "10" }, { label: "50", value: "50" }, { label: "100", value: "100" },]
const ClinicList = (props) => {
    const { l, role, userId } = props;
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({});
    const [clinics, setClinics] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [nextToken, setnextToken] = useState(null);
    const [prevToken, setprevToken] = useState([]);
    const display = 10;
    const [admins, setAdmins] = useState([]);
    const [assignTo, setAssign] = useState('');

    useEffect(() => {
        if (role === "SA") {
            getAllAdmins().then(res => {
                let _admins = [{
                    value: "",
                    label: l.select_admin
                }]
                res.data.forEach(ad => {
                    _admins.push({
                        label: ad.companyName,
                        value: ad.userId
                    })
                });
                setAdmins(_admins);
            }).catch(err => {
                console.log("err in all admin ==== ", err);
            })
        } else if (role === "CA") {
            setAssign(userId)
        }
    }, [role, userId]);

    useEffect(() => {
        // if (display !== '') {
            setnextToken(null);
            setprevToken([]);
            loadClinics(null, null);
        // }
    }, [display, assignTo, search]);

    const loadClinics = useCallback((token, adminid) => {
        setLoading(true);

        let _s = search && search !== '' ? `&searchKey=${search.toLowerCase()}` : '';
        // _s += adminid && adminid !== '' ? `&adminId=${adminid}` : '';
        // _s += role === "CA" ? '' : '';

        getUsers('clinic', _s, token, display).then(res => {
            if (res && res.data && res.data.length > 0) {
                setClinics([...res.data]);
                setnextToken(res.token ? res.token : null);
            } else {
                setnextToken(null);
                setClinics([]);
            }
            setLoading(false);
        }).catch(err => {
            console.log("err in get clinics === ", err);
            setnextToken(null);
            setprevToken([]);
            setClinics([]);
            if(API.isCancel(err)) {
                console.log("API is canceled................");
            } else {
                setLoading(false);
            }
        })
    }, [search, display])

    const handleNext = () => {
        if (nextToken !== null) {
            let _prevToken = [...prevToken];
            _prevToken.push(nextToken);
            setprevToken([..._prevToken]);
            assignTo !== '' ? loadClinics(nextToken, assignTo) : loadClinics(nextToken, null);
        }
    }

    const handlePrevious = () => {
        if (prevToken && prevToken.length > 0) {
            let _prevToken = [prevToken];
            setnextToken(_prevToken.pop());
            setprevToken([..._prevToken]);
            let _t = _prevToken[_prevToken.length - 1] ? _prevToken[_prevToken.length - 1] : null;
            assignTo !== '' ? loadClinics(_t, assignTo) : loadClinics(_t, null);
        }
    }

    const handleSlide = () => {
        setOpen(prevState => !prevState);
    }

    const handleProfileSlide = useCallback((data) => {
        setData(data);
        setOpen(prevState => prevState ? prevState : !prevState);
    }, [])

    // const handleApply = () => {
    //     if (assignTo !== '') {
    //         loadClinics(null, assignTo);
    //     }
    // }

    // const handleClear = () => {
    //     setAssign('');
    // }

    return (
        <div className="">
            <div className="listActionBlock">
                <div className="searchCntnr">
                    <div className="searchBox searchFull">
                        <div className="searchForm">
                            <input className="textbox" type="text" placeholder={l.plc_search}
                                value={search}
                                onChange={(e) => setSearch(e.target.value)} />
                        </div>
                    </div>
                </div>
                {/* <div className="filterRowBlock">
                    <div className="labelTxtBlock">
                        <span>{l.filter}</span>
                    </div>
                    <IconSelect className="filterSelect"
                        placeholder="Filter"
                        items={filterList}
                        value={filtList}
                        onChange={handleChange}
                        src="/images/icons/filter.png"
                    />
                </div> */}
                <div className="inlineItemContainer">
                    <div className="inlineItemGroup">
                        {/* {clinics && clinics.length && <Button size="sm" className="btn" type="outLine"
                            label={
                                <div className="alignCenter">
                                    <div className="imgIcon Xs"><img className="img primary" src="/images/icons/export.png" alt="icon" /></div>
                                    <span>{l.export}</span>
                                </div>} />} */}
                        {clinics && clinics.length > 0 && <Link className="inlineLink Sm " to="/admin-createusers?cId"><span className="txtPlus">{l.new_clinic}</span></Link>}
                    </div>
                </div>
            </div>
            <div className="rprtAtnRow flexWrap">
                <div className="halfRow ">
                    {/* <span className="spanTxt">{l.show} {clinics && clinics.length + '/' + display}</span> */}
                    <span className="spanTxt">{l.showing} 1 - 10 of 37 {l.entries}</span>
                    {/* <DropDownSm
                        placeholder="10"
                        items={drop}
                        value={display}
                        onChange={(e) => { setDisplay(e.target.value); }}
                        size="smallSize"
                    /> */}
                </div>
                <div className="halfRow makeFull">
                    <div className="webFltr">
                        {role === "SA" &&
                        <div className="webFltrItem">
                            <DropDown
                                placeholder={l.ass_to}
                                items={admins}
                                value={assignTo}
                                onChange={(e) => setAssign(e.target.value)}
                                size="fullWidth"
                            />
                        </div>
                        }
                        {/* <div className="webFltrItem cardFlex0">
                            {assignTo !== '' && <Button
                                label={l.clear}
                                type="outLine"
                                size="md"
                                growOne="growOne"
                                onClick={handleClear}
                            />}
                            <Button
                                label={l.apply}
                                type="primary"
                                size="md"
                                growOne="growOne"
                                onClick={handleApply}
                            />
                        </div> */}
                    </div>
                    {/*  <DropDown
                        placeholder={l.ass_to}
                        items={admins}
                        value={assignTo}
                        onChange={(e) => setAssign(e.target.value)}
                    />} */}
                </div>
                <div className="halfRow">
                    <div className="prevNxtBox">
                        <div className="prevBtn" disabled={!prevToken && (prevToken && prevToken.length <= 0)} onClick={handlePrevious}>
                            <span className={prevToken && prevToken.length > 0 ? "activeTxt active" : "activeTxt inactive"} >{l.previous}</span>
                        </div>
                        <div className="nxtBtn" disabled={nextToken === null} onClick={handleNext}>
                            <span className={nextToken !== null ? "activeTxt active" : "activeTxt inactive"} > {l.next}</span>
                        </div>
                    </div>
                </div>
            </div>
            <ul className="cntcListGroup pos-rel">
                {loading && <Loader />}
                {clinics && clinics.length > 0 ? clinics.map(clinicItem => (
                    <ClinicListItem data={clinicItem} key={clinicItem.userId} reloadData={loadClinics} handleSlide={handleProfileSlide} />
                )) : !loading && <NoData src="/images/icons/pending-new.png" label= {l.no_data} btnAction={true} btnLabel={l.new_clinic} handleButton={() => history.push(`/admin-createusers?cId`)}/>
                }
            </ul>
            {/* <div className="btnSpaceGroup">
                <Button
                    size="md"
                    className="btn"
                    disabled={!prevButton}
                    type={prevButton ? "primary" : "secondary"}
                    label={l.previous}
                    onClick={handlePrevious}
                />
                <Button
                    size="md"
                    className="btn"
                    disabled={!nextButton}
                    type={nextButton ? "primary" : "secondary"}
                    label={l.next}
                    onClick={handleNext}
                />
            </div> */}
            {open &&
                <SlideInClinicProfile open={open} closeSlide={handleSlide} data={data} />}
        </div>
    )
}

export default ClinicList;